export const formatCPF = (value: string): string => {
  // Remove todos os caracteres não numéricos
  const numericValue = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos (CPF)
  const cpf = numericValue.slice(0, 11);
  
  // Aplica a máscara de CPF: 000.000.000-00
  if (cpf.length <= 3) {
    return cpf;
  } else if (cpf.length <= 6) {
    return `${cpf.slice(0, 3)}.${cpf.slice(3)}`;
  } else if (cpf.length <= 9) {
    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6)}`;
  } else {
    return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(9)}`;
  }
};

export const formatPhone = (value: string): string => {
  // Remove todos os caracteres não numéricos
  const numericValue = value.replace(/\D/g, '');
  
  // Limita a 11 dígitos (telefone com DDD)
  const phone = numericValue.slice(0, 11);
  
  // Aplica a máscara de telefone: (00) 00000-0000
  if (phone.length <= 2) {
    return phone.length ? `(${phone}` : '';
  } else if (phone.length <= 7) {
    return `(${phone.slice(0, 2)}) ${phone.slice(2)}`;
  } else {
    return `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
  }
};

export const formatCEP = (value: string): string => {
  // Remove todos os caracteres não numéricos
  const numericValue = value.replace(/\D/g, '');
  
  // Limita a 8 dígitos (CEP)
  const cep = numericValue.slice(0, 8);
  
  // Aplica a máscara de CEP: 00000-000
  if (cep.length <= 5) {
    return cep;
  } else {
    return `${cep.slice(0, 5)}-${cep.slice(5)}`;
  }
};

export const validateCPF = (cpf: string): boolean => {
  // Remove caracteres não numéricos
  const numericCPF = cpf.replace(/\D/g, '');
  
  // Verifica se tem 11 dígitos
  if (numericCPF.length !== 11) {
    return false;
  }
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(numericCPF)) {
    return false;
  }
  
  // Validação do primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(numericCPF.charAt(i)) * (10 - i);
  }
  let remainder = sum % 11;
  let dv1 = remainder < 2 ? 0 : 11 - remainder;
  
  if (parseInt(numericCPF.charAt(9)) !== dv1) {
    return false;
  }
  
  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(numericCPF.charAt(i)) * (11 - i);
  }
  remainder = sum % 11;
  let dv2 = remainder < 2 ? 0 : 11 - remainder;
  
  if (parseInt(numericCPF.charAt(10)) !== dv2) {
    return false;
  }
  
  return true;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
};

export const validateCEP = (cep: string): boolean => {
  // Remove caracteres não numéricos
  const numericCEP = cep.replace(/\D/g, '');
  
  // Verifica se tem 8 dígitos
  if (numericCEP.length !== 8) {
    return false;
  }
  
  return true;
};

export const validatePhone = (phone: string): boolean => {
  // Remove caracteres não numéricos
  const numericPhone = phone.replace(/\D/g, '');
  
  // Verifica se tem entre 10 e 11 dígitos (com DDD)
  if (numericPhone.length < 10 || numericPhone.length > 11) {
    return false;
  }
  
  return true;
};
